var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogogrey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.418 13.9869H27.6255C26.7682 13.9869 26.0731 14.6819 26.0731 15.5393V18.1568H37.416C37.9498 18.1568 38.3864 18.5935 38.3864 19.1272V25.963C38.3864 26.4962 37.9502 26.9325 37.417 26.9325H26.0731V39.7311C26.0731 40.2642 25.6368 40.7006 25.1037 40.7006H18.265V18.4834H21.3555C21.7671 18.4834 22.0244 18.0377 21.8186 17.6812L16.4795 8.4356C18.9493 4.85537 23.5013 4.19543 27.6728 4.19543C31.89 4.19543 35.4297 4.48541 37.417 4.72798C37.9506 4.7753 38.3864 5.16397 38.3864 5.69849V13.0185C38.3864 13.5511 37.9507 13.9869 37.418 13.9869ZM14.6208 15.5385V39.7313C14.6208 40.2641 15.0566 40.6999 15.5892 40.6999H10.7095C10.4142 40.6999 10.1748 40.4605 10.1748 40.1651V18.4827H7.08335C6.67173 18.4827 6.4145 18.037 6.62027 17.6806L13.7507 5.33201C13.9564 4.97554 14.4709 4.97554 14.6768 5.33201L16.4686 8.43485C15.3215 10.0977 14.6208 12.3864 14.6208 15.5385Z",
    fill: "#959595"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogogrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logogrey.1a29cf69.svg";
export { ForwardRef as ReactComponent };